import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';
import { ThemeTone } from '../../../core/types/common.types';

interface StatCardProps {
  title: string;
  subtitle: string;
  icon: ReactNode;
  tone: ThemeTone;
  children: ReactNode;
}

function StatCard({ title, subtitle, icon, tone, children }: StatCardProps) {
  return (
    <Paper
      elevation={4}
      sx={{
        height: '100%',
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          px: { xs: 2.5, md: 2 },
          pt: { xs: 2.5, md: 2 },
          pb: 2,
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 46,
              height: 46,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: `${tone}.lighter`,
              color: `${tone}.dark`,
              flexShrink: 0,
              border: 1,
              borderColor: `${tone}.light`,
            }}
          >
            {icon}
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" component="h3" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {title}
            </Typography>

            <Typography variant="body2" component="p" color="text.secondary" sx={{ mt: 0.25 }}>
              {subtitle}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ p: { xs: 2.5, md: 3 } }}>{children}</Box>
    </Paper>
  );
}

export default StatCard;
